import { Injectable } from "@angular/core";
import { PaymentsType } from '../../core/models/payments-type';
import { PaymentMethodTypeEnum } from '../../core/enums/payment-methods-type.enum-';

@Injectable({
  providedIn: "root",
})
export class PaymentsTypeService {
  private paymentsType: PaymentsType[] = [];

  constructor() {
    this.fillPromos();
  }

  private fillPromos(): void {
    this.addPaymentType({
      code: 6,
      value: "Visa",
      type: PaymentMethodTypeEnum.STRIPE_CHECKOUT,
      img: "visa.svg",
      heightValue: 25,
    });

    this.addPaymentType({
      code: 7,
      value: "Mastercard",
      type: PaymentMethodTypeEnum.STRIPE_CHECKOUT,
      img: "mastercard.svg",
      heightValue: 35,
    });

    this.addPaymentType({
      code: 8,
      value: "American Express",
      type: PaymentMethodTypeEnum.STRIPE_CHECKOUT,
      img: "amex.svg",
      heightValue: 35,
    });

    this.addPaymentType({
      code: 5,
      value: "Paypal",
      type: PaymentMethodTypeEnum.PAYPAL_OPTION_REQUEST,
      img: "paypal.svg",
      heightValue: 35,
    });

    this.addPaymentType({
      code: 4,
      value: "Wells",
      type: PaymentMethodTypeEnum.FOREIGNS_BANKS,
      img: "wells.svg",
      heightValue: 35,
    });

    this.addPaymentType({
      code: 3,
      value: "td",
      type: PaymentMethodTypeEnum.FOREIGNS_BANKS,
      img: "td.svg",
      heightValue: 35,
    });

    this.addPaymentType({
      code: 2,
      value: "Zelle",
      type: PaymentMethodTypeEnum.FOREIGNS_BANKS,
      img: "zelle.svg",
      heightValue: 25,
    });

    this.addPaymentType({
      code: 9,
      value: "Transfer in Ec",
      type: PaymentMethodTypeEnum.LOCAL_TRANSFER,
      img: "ecuador-account.svg",
      heightValue: 35,
    });

    this.addPaymentType({
      code: 9,
      value: "Direct transfer",
      type: PaymentMethodTypeEnum.LOCAL_TRANSFER,
      img: "direct-transfer.svg",
      heightValue: 35,
    });

    this.addPaymentType({
      code: 1,
      value: "bank international",
      type: PaymentMethodTypeEnum.FOREIGNS_BANKS,
      img: "international-bank.svg",
      heightValue: 35,
    });
    this.addPaymentType({
      code: 11,
      value: "wire-transfer",
      type: PaymentMethodTypeEnum.FOREIGNS_BANKS,
      img: "wire-transfer.svg",
      heightValue: 35,
    });
    this.addPaymentType({
      code: 1,
      value: "stripe",
      type: PaymentMethodTypeEnum.GENERAL_TRANSFER,
      img: "stripe.svg",
      heightValue: 35,
    });
  }

  private addPaymentType(promo: PaymentsType) {
    this.paymentsType.push(promo);
  }

  public getPaymentsType(): PaymentsType[] {
    return this.paymentsType;
  }

  public getPaymentsByType(type: number): PaymentsType[] {
    let response = [];
    for (const paymentType of this.getPaymentsType()) {
      if (paymentType.type === type) {
        response.push(paymentType);
      }
    }
    return response;
  }

  public getAllPaymentsBytypes(types: number[]) {
    let response = [];
    for (const paymentType of this.getPaymentsType()) {
      let index = types.find((item) => item === paymentType.type);
      if (index && index >= 0) {
        response.push(paymentType);
      }
    }
    return response;
  }

  public getImagesByListNames(names: string[]) {
    let response = [];
    for (const paymentType of this.getPaymentsType()) {
      let index = names.findIndex((item) => item === paymentType.img);
      if (index >= 0) {
        response.push(paymentType);
      }
    }
    return response;
  }

}
